import { useCallback } from "react";

import { Modal } from "../../services";
import {
	isTextMatchingLeadingStarsFilterHelper,
	sortByNumberOrString,
	isTextMatchingAnySegmentFilterHelper,
} from "../../utils";
import { ColumnId } from "../../constants/tables/customerSelectTab";

import { isQuery, isLimit, isOrder } from ".";

const useClientForCustomerDiscountPlanSubHandler =
	(): useClientForCustomerDiscountPlanSubHandler.Props => {
		const convertDataToFullname = useCallback(
			(client: Modal.ModelSimpleForMultySelectModalClient): string => {
				const defaultTitle = "Unknown";

				const lastName = client?.lastName ? client?.lastName : "";
				const firstName = client?.firstName ? client?.firstName : "";
				const fatherName = client?.fatherName ? client?.fatherName : "";

				const fullName =
					`${lastName} ${firstName} ${fatherName}`.trim();

				const clientName =
					fullName.length > 0 ? fullName : defaultTitle;

				const clientPhone = client?.phone
					? client?.phone
					: defaultTitle;

				const retval = `${clientPhone} (${clientName})`;

				return retval;
			},
			[],
		);

		const getQueryAndLimitClientForCustomerDiscountPlanSubHandler =
			useCallback(
				(
					data: useClientForCustomerDiscountPlanSubHandler.SmallSubscribeOptions,
					dataSubscribe: Modal.ModelForModalCustomerDiscountPlan[],
				): Modal.ModelForModalCustomerDiscountPlan[] => {
					const { limit, query, order } = data;

					if (!Array.isArray(dataSubscribe)) {
						return [];
					}

					let retval = [...(dataSubscribe || [])];

					if (isQuery(query)) {
						retval = retval.filter((item) => {
							const fullName = convertDataToFullname(item);
							return (
								isTextMatchingLeadingStarsFilterHelper(
									fullName,
									query,
								) ||
								isTextMatchingAnySegmentFilterHelper(
									fullName,
									query,
								)
							);
						});
					}

					// export enum ColumnId {
					// 	LastName = "lastName",
					// 	FirstName = "firstName",
					// 	FatherName = "fatherName",
					// 	Phones = "phones",
					// 	Company = "company",
					// 	App = "app",
					// }

					if (isOrder(order)) {
						const [[dataKey, sortType] = []] = Object.entries(
							order || {},
						);
						const isSort =
							typeof sortType === "string" &&
							typeof dataKey === "string" &&
							["asc", "desc"].includes(sortType.toLowerCase());

						if (isSort) {
							const isAscending =
								sortType.toLowerCase() === "asc";
							const sortOrder = isAscending ? 1 : -1;

							if (dataKey === ColumnId.LastName) {
								const sort = retval.sort((prev, next) => {
									const prevValue = prev.lastName ?? "";
									const nextValue = next.lastName ?? "";
									return (
										sortByNumberOrString(
											prevValue,
											nextValue,
										) * sortOrder
									);
								});

								retval = sort;
							}

							if (dataKey === ColumnId.FirstName) {
								const sort = retval.sort((prev, next) => {
									const prevValue = prev.firstName ?? "";
									const nextValue = next.firstName ?? "";
									return (
										sortByNumberOrString(
											prevValue,
											nextValue,
										) * sortOrder
									);
								});

								retval = sort;
							}

							if (dataKey === ColumnId.FatherName) {
								const sort = retval.sort((prev, next) => {
									const prevValue = prev.fatherName ?? "";
									const nextValue = next.fatherName ?? "";
									return (
										sortByNumberOrString(
											prevValue,
											nextValue,
										) * sortOrder
									);
								});

								retval = sort;
							}

							if (dataKey === ColumnId.Company) {
								const sort = retval.sort((prev, next) => {
									const prevValue = prev.taxiServiceId || -1;
									const nextValue = next.taxiServiceId || -1;
									return (
										sortByNumberOrString(
											prevValue,
											nextValue,
										) * sortOrder
									);
								});

								retval = sort;
							}

							if (dataKey === ColumnId.App) {
								const sort = retval.sort((prev, next) => {
									const prevValue = prev.isApp ? 1 : -1;
									const nextValue = next.isApp ? 1 : -1;
									return (
										sortByNumberOrString(
											prevValue,
											nextValue,
										) * sortOrder
									);
								});

								retval = sort;
							}
						}
					}

					if (isLimit(limit)) {
						retval = retval.slice(0, limit);
					}

					return retval;
				},
				[convertDataToFullname],
			);

		return {
			getQueryAndLimitClientForCustomerDiscountPlanSubHandler,
		};
	};

declare namespace useClientForCustomerDiscountPlanSubHandler {
	interface Props {
		getQueryAndLimitClientForCustomerDiscountPlanSubHandler: (
			data: SmallSubscribeOptions,
			dataSubscribe: Modal.ModelForModalCustomerDiscountPlan[],
		) => Modal.ModelForModalCustomerDiscountPlan[];
	}

	interface SmallSubscribeOptions {
		order?: any;
		query?: string;
		limit?: number;
	}
}

export default useClientForCustomerDiscountPlanSubHandler;
